(ns frontend.test.validation.utils
  (:require
   [common.util :as cu]
   [frontend.test.validation.model :as m]))

(defn validate-constraint
  [_context [constraint-key c-val] value]
  (case constraint-key
    :constraint/mandatory-fn
    (when (c-val value nil)
      {:error-kw :mandatory
       :error-message "Mandatory field must contain value"})
    :constraint/string-min-length
    (when (< (count (cu/str-trim-lcase value)) 2)
      {:error-kw :min-length
       :error-message (str "Must be at least " c-val " characters")})
    :constraint/unique-name
    (when (= (cu/str-trim-lcase value) "hello")
      {:error-kw :unique-name
       :error-message "The name must be unique"
       :conflicting-id 17592186064185})
    nil))

(defn entity-value-errors
  [{:keys [entity-value]} [_ {:keys [attribute]}]]
  (let [{:keys [constraints]} (get m/attribute-defs-by-attribute attribute)]
    (->> constraints
         (mapv (fn [constraint]
                 (validate-constraint {:entity nil :etc :info}
                                      constraint entity-value)))
         (filterv some?)
         ;; not-empty retains type:
         not-empty)))

(defn validate-all
  [{:keys [entity-edits] :as args} [_ ctx]]
  ;;TODO reduce m/attribute-defs, attach each validation to key
  (->> m/attribute-defs
       (mapv (fn [{:keys [attribute]}]
               [attribute (entity-value-errors {:entity-value (get entity-edits attribute)}
                                               [nil (assoc ctx :attribute attribute)])]))
       (filterv (comp some? second))
       (into {})
       not-empty))
